const api = 'https://ngo.sourav.xyz/api';

const ConfigApi = {
  // Auth
  LOGIN: `${api}/login`,
  REGISTER: `${api}/registration`,
  LOGOUT: `${api}/logout`,
  INIT:`${api}/activity/init`,

  // Common
  COMMON_ACC_LIST: `${api}/common/account/list`,
  BANK_LIST:`${api}/common/bank/list`,
  
  // Order
  DASHBOARD_INFO: `${api}/dashboard/info`,

  //Member
  MEMBER_LIST:`${api}/member/list`,
  MEMBER_CREATE:`${api}/member/create`,
  MEMBER_UPDATE:`${api}/member/update`,

 //Collection
  COLLECTION_LIST:`${api}/collection/list`,
  COLLECTION_CREATE:`${api}/collection/create`,

  //Member
  BORROWER_LIST:`${api}/borrower/list`,
  BORROWER_CREATE:`${api}/borrower/create`,
  BORROWER_UPDATE:`${api}/borrower/update`,

  //Local Invest
  LOCAL_INVEST_LIST:`${api}/local-invest/list`,
  LOCAL_INVEST_CREATE:`${api}/local-invest/create`,
  LOCAL_INVEST_UPDATE:`${api}/local-invest/update`,
  //Local Invest
  OTHER_INVEST_LIST:`${api}/other-invest/list`,
  OTHER_INVEST_CREATE:`${api}/other-invest/create`,
  OTHER_INVEST_UPDATE:`${api}/other-invest/update`,
  //Local Invest
  TRANSACTION_LIST:`${api}/finance/transaction/list`,
  TRANSACTION_CREATE:`${api}/finance/transaction/create`,
  TRANSACTION_UPDATE:`${api}/finance/transaction/update`,

  //Local Invest
  INCOME_LIST:`${api}/income/list`,
  INCOME_CREATE:`${api}/income/create`,
  INCOME_UPDATE:`${api}/income/update`,
  //Account
  ACCOUNT_LIST:`${api}/account/list`,
  ACCOUNT_CREATE:`${api}/account/create`,
  ACCOUNT_UPDATE:`${api}/account/update`,

};

export default ConfigApi;
